export const environment = {
  production: false,
  // apiUrl: 'http://127.0.0.1:8000/api/',
  //  socketUrl: 'http://localhost:4000',
  // apiUrl: 'https://auctionfe.inndeve.com/api/',
  // socketUrl:'https://auctionfe.inndeve.com',

  // Development
  // apiUrl: 'https://auctiondev.mosandah.com.sa/api/',
  // socketUrl: 'https://auctiondev.mosandah.com.sa',
  streamUrlPublish: 'wss://origin.inndeve.com:443/WebRTCAppEE/websocket?target=origin',
  streamUrlPlay: 'wss://edge.inndeve.com:443/WebRTCAppEE/websocket',
  streamUrl: 'https://edge.inndeve.com:443',
  // Testing
  apiUrl: 'https://auctiontest.mosandah.com.sa/api/',
  socketUrl: 'https://auctiontest.mosandah.com.sa'
 // stage
  // apiUrl: 'https://tawreeda.com/api/',
  // socketUrl:'https://tawreeda.com'
};
